import { SvgIcon, type SvgIconProps } from "@mui/material";

import orbitLogoUrl from "./OrbitLogo.svg";

/** Nav-bar style Orbit logo (SVG asset). */
export function OrbitLogo({ ...props }: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 1409.92 793.08" {...props} sx={{ height: "unset", width: "unset", ...props.sx }}>
      <image height="793.08" href={orbitLogoUrl} preserveAspectRatio="xMidYMid meet" width="1409.92" />
    </SvgIcon>
  );
}
